import React from "react";
import mainTheme from "../../newComponent/themeprovider/mainTheme/MainTheme";
import { Button, Grid, Stack, ThemeProvider, Typography } from "@mui/material";
import InputSelectWithTopLable from "../../newComponent/themeprovider/textField/InputSelectWithTopLable";
import InputField from "../../newComponent/themeprovider/textField/InputFiledComp";
import CustomNewButton from "../../newComponent/themeprovider/button/CustomNewButton";

export default function SendAssignmentsForm({onClose}) {
  return (
    <>
      <ThemeProvider theme={mainTheme}>
        <Grid container spacing={3}>
          

          <Grid item xs={12}>
            <InputSelectWithTopLable
              label="Selct Assignment Type"
              name="assignmentType"
              placeholder="Assignment Type"
              options={[
                { id: 1, name: "Reading" },
                { id: 2, name: "Writing" },
                { id: 3, name: "Speaking" },
                { id: 4, name: "Listening" },
              ]}
            />
          </Grid>

          {/* Assignment name */}
          <Grid item xs={12}>
            <InputSelectWithTopLable
              label="Select Assignment"
              name="assignmentTitle"
              placeholder="Assignment Title"
              options={[{ id: 1, name: "Reading Assignment" }]}
            />
          </Grid>
            {/* Dates */}
                <Grid item xs={12} md={6}>
              
                  <InputField
                    label="Start Date"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputField
                    fullWidth
                    size="small"
                    type="date"
                    label="Due Date"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                
                  <InputSelectWithTopLable
                    label="Assign To"
                    multiple
                    options={[
                      { value: "1", label: "Ayesha" },
                      { value: "2", label: "Deepak" },
                    ]}
                  />
                </Grid>

                 {/* Buttons */}
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" onClick={onClose}>Cancel</Button>

                    <CustomNewButton label="Send" />
                  </Stack>
                </Grid>
           

        </Grid>
      </ThemeProvider>
    </>
  );
}
